import { useJsonForms, withJsonFormsControlProps } from "@jsonforms/react";
import {
  ControlProps,
  rankWith,
  isDescriptionHidden,
  isDateControl,
} from "@jsonforms/core";
import React, { useEffect, useState, useRef } from "react";
import { getAllBanks } from "services";
import CustomSearchDropdown from "../../../../../../shadcn/components/custom/dropdown/CustomSearchDropdown";

interface OptionProps {
  label?: string; // Display name
  value?: string; // Unique identifier
}
export const BankFieldTypeRenderer = ({
  data,
  handleChange,
  path,
  schema,
  uischema,
}: ControlProps) => {
  const ctx = useJsonForms();
  const dropDownOptions = uischema?.options?.additionalData || {};
  const [customError, setCustomError] = useState("");
  const [citiesData, setCitiesData] = useState<OptionProps[]>();
  const positionRef = useRef<HTMLInputElement>(null);

  const show = uischema?.options?.show;
  useEffect(() => {
    if (show == false) {
      handleChange(path, {});
    }
  }, [show]);

  useEffect(() => {
    const errorData = ctx?.core?.errors;
    let flag = false;
    errorData?.forEach((error: any) => {
      if (error?.instancePath === "/" + path) {
        setCustomError(error?.message);
        flag = true;
      } else if (
        error?.instancePath === "" &&
        error?.params?.missingProperty === path
      ) {
        setCustomError("Required Field");
        flag = true;
        return;
      }
    });

    if (!flag) setCustomError("");
    else {
      if (positionRef.current) {
        positionRef.current.scrollIntoView({
          behavior: "smooth",
        });
      }
    }
  }, [ctx?.core?.errors]);

  useEffect(() => {
    const fetch = async () => {
      try {
        const response: any = await getAllBanks();
        if (response) {
          const fileteredData = response.map((city: any) => {
            return {
              uuid: city.uuid,
              label: city.name,
              value: city.slug,
            };
          });
          setCitiesData(fileteredData);
        }
      } catch (err) {
        console.log("error here", err);
      }
    };
    fetch();
  }, []);

  return show === false ? (
    <></>
  ) : (
    <div ref={positionRef} className="w-full  relative ">
      <div className="h-[50px] bg-white border ">
        <CustomSearchDropdown
          onValueChange={(value: any) => {
            handleChange(path, value);
          }}
          placeholderText=""
          defaultSelected={
            data !== ""
              ? citiesData?.find((item: any) => data?.value === item.value)
              : undefined
          }
          dataSource={() => {
            return Promise.resolve(citiesData || []);
          }}
          styles={{
            placeholderClass: `pr-1 ${
              data ? "pt-4" : "pt-6"
            } text-brand-textLightGrey overflow-hidden`,
            triggerOuterClass: "h-full",
            formfieldClass: "h-full",
          }}
        />
        <div
          className={`absolute top-1 text-[10px] transition-all duration-300  left-3 ${"text-brand-borderGrey"}`}
        >
          {schema?.title}
        </div>
      </div>{" "}
      {customError && (
        <label
          htmlFor="name"
          className={"text-brand-textRed text-web-body-sm ml-2"}
        >
          {customError}
        </label>
      )}
    </div>
  );
};

export default withJsonFormsControlProps(BankFieldTypeRenderer);
